const tr = {
  pins: {
    attributes: {
      id: 'ID',
      product: 'Produto',
      product_id: 'Produto',
      code: 'código (PIN)',
      pan: 'código (PAN)',
      status: 'Status',
      is_active: 'Ativo',
      batch: 'Lote',
      serial: 'Serial',
      product_quantity: 'Quantidade de consultas total',
      quantity_used: 'Quantidade de consultas utilizadas',
      quantity_pending: 'Quantidade de consultas pendentes',
      user: 'Usuário',
      activated_at: 'Ativado em',
      expires_at: 'Expira em',
      desactived_at: 'Desativado em',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras: {
      create: 'Novo PIN',
      edit: 'Editando PIN',
      show: 'Visualizando PIN',
      delete: 'Excluir PIN',
      search: 'Digite o ID, PIN ou PAN',
      dateType: 'Tipo de data',
      date_init: 'Data inicial',
      date_end: 'Data final',
    },
    defSingular: 'PIN',
    defPlural: 'PINs',
  },
};

export default tr;
